<!-- BEGIN #header -->
<div id="header" class="app-header">
  <!-- BEGIN desktop-toggler -->
  <div class="desktop-toggler" *ngIf="showNavigation">
    <button type="button" (click)="app.sideBarCollapsed = !app.sideBarCollapsed" class="menu-toggler" data-bs-toggle="app-sidebar-collapsed" data-bs-target=".indicium-cloud">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>
  </div>
  <!-- BEGIN desktop-toggler -->
  
  <!-- BEGIN mobile-toggler -->
  <div class="mobile-toggler" *ngIf="showNavigation">
    <button type="button"  (click)="app.menuOpen = !app.menuOpen" class="menu-toggler" data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>
  </div>
  <!-- END mobile-toggler -->
  
  <!-- BEGIN brand -->
  <div class="brand">
    <a href="#" class="brand-logo">
      <span class="brand-img" [style.background-image]="'url(' + app.logoUrl + ')'">
        <span class="brand-img-text text-theme"></span>
      </span>
      <span class="brand-text" *ngIf="app == null || app.applicationName == null || app.applicationName == ''">INDICIUM Cloud</span>
      <span class="brand-text" *ngIf="app && app.applicationName">{{app.applicationName}}</span>
    </a>
  </div>
  <!-- END brand -->
  
  <!-- BEGIN menu -->
  <div class="menu">

    <!-- GLOBAL SEARCH-->
    <!--<div class="menu-item dropdown">
      <a href="#" data-toggle-class="app-header-menu-search-toggled" data-toggle-target=".app" class="menu-link">
        <div class="menu-icon"><i class="bi bi-search nav-icon"></i></div>
      </a>
    </div>-->
   
    <!-- Day/Night Toggle -->
    <div class="menu-item dropdown dropdown-mobile-full">
      <a class="menu-link" id="dropdown-customer" (click)="toggleTheme()">
        <div class="menu-icon">
            <i *ngIf="theme=='dark'" class="bi bi-sun nav-icon"></i>
            <i *ngIf="theme=='light'" class="bi bi-moon nav-icon"></i>
        </div>
      </a>
    </div>
    


  </div>
  <!-- END menu -->
  
  <!-- BEGIN menu-search -->
  <form class="menu-search" method="POST" name="header_search_form">
    <div class="menu-search-container">
      <div class="menu-search-icon"><i class="bi bi-search"></i></div>
      <div class="menu-search-input">
        <input type="text" class="form-control form-control-lg" placeholder="Search menu..." />
      </div>
      <div class="menu-search-icon">
        <a href="#" data-toggle-class="app-header-menu-search-toggled" data-toggle-target=".app"><i class="bi bi-x-lg"></i></a>
      </div>
    </div>
  </form>
  <!-- END menu-search -->


  <div class="modal fade"  id="modalXl">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        ...
      </div>
    </div>
  </div>
  
</div>
<!-- END #header -->